import { elements, html, slotted } from "@microsoft/fast-element";
import type { NatGenAccordion } from "./accordion.js";

export const accordionTemplate = html<NatGenAccordion>`
    <slot
        ${slotted({ property: "slottedAccordionItems", filter: elements() })}
    ></slot>
`;
